import React from "react";
import TextContentInput from "../../component/input/TextContentInput";
import useFormPermission from "../useFormPermission";

const PermissionableTextContentInput = ({ ...props }) => {
  const hasFormPermission = useFormPermission();
  const disabled = !hasFormPermission(props.source);
  return <TextContentInput {...props} disabled={disabled} />;
};
export default PermissionableTextContentInput;
